import React from 'react'
import { makeStyles, useTheme } from '@material-ui/styles'
import Theme, { Palette } from 'core/themes/model'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'

const useStyles = makeStyles<Theme>((theme) => ({
  cell: {
    display: 'flex',
    gap: 6,
    alignItems: 'center',
  },
  dot: {
    fontSize: 8,
  },
}))

export const booleanDotColor = (bool, palette) => (bool ? palette.green[700] : palette.red[700])

interface Props {
  value: any
  dotColorFn?: (value: any, palette: Palette) => string
}

export default function DotValueCell({ value, dotColorFn }: Props) {
  const theme = useTheme<Theme>()
  const dotColor = dotColorFn
    ? dotColorFn(value, theme.palette)
    : booleanDotColor(value, theme.palette)
  const classes = useStyles()

  return (
    <div className={classes.cell}>
      <FontAwesomeIcon
        className={classes.dot}
        style={{ color: dotColor || theme.palette.green[700] }}
        solid
      >
        circle
      </FontAwesomeIcon>
      <Text variant="body2">{String(value)}</Text>
    </div>
  )
}
